var _path, _path2, _rect, _path3, _circle, _circle2, _path4, _path5, _path6, _mask, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 89,
    viewBox: "0 0 94 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54912 57.04C-6.11653 34.8072 9.68155 14.2187 32.2675 5.09277C54.8534 -4.0332 75.6743 1.75913 84.34 23.9919C93.0056 46.2247 102.108 76.7218 79.5219 85.8477C56.936 94.9737 11.2148 79.2728 2.54912 57.04Z",
    fill: "#EEF0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54657 23.4484L15.086 23.4707M17.2761 18.6074L12.6021 14.3388M21.6592 15.4904L21.3099 10.5893",
    stroke: "#0F255F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.7509,
    y: 20.8117,
    width: 55.3785,
    height: 59.2833,
    rx: 8,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1294 62.341V28.8116C76.1294 24.3934 72.5477 20.8116 68.1294 20.8116H28.7509C24.3326 20.8116 20.7509 24.3934 20.7509 28.8116V72.095C20.7509 76.5133 24.3326 80.095 28.7509 80.095H56.866",
    stroke: "#0F255F",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.888,
    cy: 60.2171,
    r: 11.4304,
    fill: "white",
    stroke: "#0F255F",
    strokeWidth: 1.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.8882,
    cy: 60.2194,
    r: 6.48745,
    fill: "white",
    stroke: "#0F255F",
    strokeWidth: 1.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8526 71.2164L67.4599 67.2152L75.0529 75.9585C76.1578 77.2308 76.0221 79.1578 74.7499 80.2627C73.4776 81.3676 71.5506 81.2319 70.4457 79.9597L62.8526 71.2164Z",
    fill: "white",
    stroke: "#0F255F",
    strokeWidth: 1.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5732 30.9382C41.1037 30.9382 40.7232 31.3188 40.7232 31.7882C40.7232 32.2577 41.1037 32.6382 41.5732 32.6382V30.9382ZM63.5411 32.6382C64.0106 32.6382 64.3911 32.2577 64.3911 31.7882C64.3911 31.3188 64.0106 30.9382 63.5411 30.9382V32.6382ZM41.5732 32.6382H63.5411V30.9382H41.5732V32.6382Z",
    fill: "#0F255F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5732 37.9851C41.1037 37.9851 40.7232 38.3656 40.7232 38.8351C40.7232 39.3045 41.1037 39.6851 41.5732 39.6851V37.9851ZM54.6039 39.6851C55.0734 39.6851 55.4539 39.3045 55.4539 38.8351C55.4539 38.3656 55.0734 37.9851 54.6039 37.9851V39.6851ZM41.5732 39.6851H54.6039V37.9851H41.5732V39.6851Z",
    fill: "#0F255F"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.2272,
    y: 30.6906,
    width: 8.95162,
    height: 9.24177,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2272,
    y: 30.6906,
    width: 8.95162,
    height: 9.24177,
    rx: 1,
    fill: "white",
    stroke: "#0F255F",
    strokeWidth: 3.4,
    mask: "url(#path-10-inside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.60652513743b9cdb709d97a8d584d5b8.svg";
export { ForwardRef as ReactComponent };